import {Component} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {AlertService} from "../../../../services/alert/alert.service";
import {FcaService} from "../../../fca/fca.service";
import {ErrorReportComponent} from "../../../control-report/cr-issue/error-report/error-report.component";

@Component({
  selector: 'app-confirmation-modal-fca-component',
  templateUrl: './confirmation-modal-fca-component.component.html',
  styleUrls: ['./confirmation-modal-fca-component.component.css']
})
export class ConfirmationModalFcaComponentComponent {
  title: string;
  message: string;
  uniqueId: any;
  fcaTypeId: any;
  param:any;
  fcaRequestId:any;
  resData: any []= [];
  failMessage:any;
  comp:string;
  uploadRes:any;
  mapData:any;
  type:any;
  constructor(public bsModalRef: BsModalRef, private alerts: AlertService,
              private fcaService: FcaService, private modalService: BsModalService) { }

  ngOnInit() {
  }

  upload(): void {
    this.alerts.loading();
    this.bsModalRef.hide();
    this.fcaService.updateUploadResult(this.comp,'proceed');
  }

  close() {
    this.bsModalRef.hide();
  }

  viewErrorReport() {
    this.bsModalRef.hide();
    let initialState = {
      generatedId: this.uniqueId,
      uploadType: this.param,
      tableName: this.uploadRes?.result?.tableName,
      primaryKey: this.uploadRes?.result?.primaryKey,
      fcaTypeId: this.fcaTypeId,
      uploadRes: this.uploadRes,
      fcaRequestId: this.fcaRequestId,
      invalid_reason: this.uploadRes?.result?.invalid_reason,
      requestType: 'Account Number',
      type: this.type,
      mapData: this.mapData
    };

    this.modalService.show(ErrorReportComponent, {
      initialState,
      backdrop: 'static', keyboard: false,
      class: 'modal-dialog modal-dialog-centered'
    });
  }

}
